<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Subjective Evalution</span>
        </v-row>
                  <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <br />
        <div id="inspire">
        <!-- <v-app id="inspire" class> -->
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <center class="heading">
                <h3>Subjective Evalution</h3>
            </center>
            <div class="box">
                    <v-row class="center">
                        <v-col xs="12" sm="12" lg="5" md="6" cols="12">
                            <v-row>
                            <label class="bold">Exam : </label>
                         <p class="info1"> {{exam_data.exam}}</p>

                            </v-row>
                        </v-col>
                        <v-col xs="12" sm="12" lg="5" md="6" cols="12">
                            <v-row>
                            <label class="bold">Subject : </label>
                            <p class="info1"> {{exam_data.course}}</p>
                            </v-row>
                        </v-col>
                    </v-row>
                                        <v-row class="center">
                        <v-col xs="12" sm="12" lg="5" md="6" cols="12">
                            <v-row>
                            <label class="bold">Student Name : </label>
                         <p class="info1"> {{exam_data.student_name}}</p>

                            </v-row>
                        </v-col>
                        <v-col xs="12" sm="12" lg="5" md="6" cols="12">
                            <v-row>
                            <label class="bold">Marks : </label>
                            <p class="info1"> {{exam_data.student_marks}}</p>
                            </v-row>
                        </v-col>
                    </v-row>

            </div>

            <div v-if="question_data.length > 0">
  <v-card>
    <v-card-title>
        <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        hide-details
      ></v-text-field> -->
    </v-card-title>
    <v-data-table
    style="margin:10px"
    class="mytable"
      :headers="headers"
      :items="question_data"
      :search="search"
    >

        <template v-slot:item.questions="{ item }">
     
     <p v-html="item.question"></p>
      </template>
    <template v-slot:item.attachment="{ item }">
        <div class="d-flex" v-if="item.anwer_files.length > 0">
            <div><i class="mdi mdi-eye eye "  style="text-align: center; color: #5cbbf6;font-size:25px;margin-right:10px" @click="viewFile(item.anwer_files)"></i></div>
            <div> <p class="mb-0" v-for="data in item.anwer_files" ><a>{{data.file_name}}</a></p></div>
        </div>
     <div v-else>
--
     </div>
      </template>
          <template v-slot:item.obtainedmarks="{ item }">
              <span style="color:red" v-if="item.invalidMarks">Obtained Marks should be less than outof marks!!</span>
      <v-text-field type="number" @input="checkMarks(item)" outlined dense v-model="item.obtained_marks" :disabled=item.isEvaluated :max=item.marks_Outof class="mt-2"></v-text-field>
      </template>
                <!-- <template v-slot:item.remark="{ item }">
      <v-text-field outlined dense ></v-text-field>
      </template> -->
                      <template v-slot:item.answer_data="{ item }">
<v-text-field
class="answer"

          name="input-7-1"
          :value="item.answer"
          rows="1"
          readonly
          @click="viewAnswer(item.answer)"
        ></v-text-field>   
           </template>
    </v-data-table>
<v-row class="justify-center">
    <v-checkbox
              v-model="approve"
              label="Approve"
              @change="approveConfirmation"
              color="success"
              hide-details
            ></v-checkbox>
            <v-btn color="success"  style="margin:12px" @click="saveMarks">Save Marks</v-btn>
</v-row>


    <template>
  <v-row justify="center">
    <v-dialog
      v-model="answer"
      scrollable
      max-width="600px"
    >
    
      <v-card>
        <v-card-title>Answer</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;">
        {{current_anwer}}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
           color="primary"
            text
            @click="answer = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


 <template>
  <v-row justify="center">
    <v-dialog
      v-model="file"
      scrollable
      max-width="1300px"
    >
    
      <v-card>
        <v-card-title>Answer files</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;text-align: center;">
            <div v-for="(data,index) in fileArr" :key="index">
                  <center><p style="background: yellow;" class="info1">File No : {{index + 1}}</p></center>
            <div v-if="data.fileType == 'pdf'">
        <embed :src="data.file_path" width="1000" height="1500"
 type="application/pdf">
    </div>
    <div v-if="data.fileType == 'img'" >
        <img :src="data.file_path" alt="" style="width: 1000px;">   
    </div>
            </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="file = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>

</template>

  </v-card>
</div>


</div>  
  </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import datetime from "vuejs-datetimepicker";
import pdf from "vue-pdf";

    export default {
        components: { datetime ,pdf},
        data: () => ({
            selected: [],
            evaluate:null,
            course:null,
            exam:null,
            overlay:true,
            exam_list:null,
            fileArr:[],
            file:false,
            approve:false,
            checked: [],
            answer:false,
            question_data:[],
            courseSrc: "",
            current_anwer:'',
            unitBlock: false,
            question_info: null,
            question_info_des: null,
            courseDes: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            crs_list: [],
            loading: false,
            exam_data : {},
        search: '',
        headers: [
          { text: 'Sr No.', value: 'srno' },
          { text: 'Question', value: 'questions' },
           { text: 'Attachments', value: 'attachment' },
          { text: 'Answer', value: 'answer_data' },
          { text: 'Marks OutOf', value: 'marks_Outof' },
          { text: 'Obtained Marks', value: 'obtainedmarks'},
        //   { text: 'Remark', value: 'remark'}
        ],
les:null,

                        show: true,
                        // src:'https://vgespl-easypariksha.s3.ap-south-1.amazonaws.com/vunet/subj_answer/5/cui99qrz1c_2.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20210322T130152Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Credential=AKIASPWL33DPURC6QC62%2F20210322%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=225941fb5e16a23beff1fd1220ab8a6301417078e1be0b0af4661ebfa28e7261',
                // src:'https://wikieducator.org/images/4/41/Logrithm_Table.pdf',
                // src: "https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/web/compressed.tracemonkey-pldi-09.pdf",
                loadedRatio: 0,
                page: 1,
                numPages: 0,
                rotate: 0,
        }),

        mounted() {
            this.exam_data = this.$route.params.examData
this.les = this.exam_data.les
            console.log('exam_data',this.exam_data);
            this.onLoad();

        },

        methods: {
checkMarks(item){
    console.log(item.obtained_marks > item.marks_Outof);
if(item.obtained_marks > item.marks_Outof){
    item.invalidMarks = true
}else{
    item.invalidMarks = false
}
console.log(item);
},
            onLoad() {
this.overlay =true
                axios
                    .post("/PaperChecker/getStudQuestion",this.exam_data)
                    .then((res) => {
                        if (res.data.msg == "200") {
this.question_data = res.data.question
this.overlay =false
                        } else {
                            this.overlay =false
                        }
                    })
                    .catch((error) => {});
            },
evaluate(){

},

saveMarks(){
    console.log(this.question_data);
            //    this.loading = true;
const data = {
    marksData : this.question_data,
    approve: this.approve,
    les:this.les
}


                            axios
                                .post("/PaperChecker/saveMarks",data )
                                .then((res) => {
                                    if (res.data.flag == "YES") {
                                      this.showSnackbar("#4CAF50", "Marks added Successfully!!");
                                    
                                      if(res.data.sum_marks){
                                          this.exam_data.student_marks = res.data.sum_marks
                                      }
                                      this.onLoad()

                                    } else {
                                    }
                                    this.unitBlock = false;
                                })
                                .catch((error) => {})
                                .finally(() => {
                                    this.loading = false;
                                });
},
approveConfirmation(){
    if(this.approve){
 this.showSnackbar("#b71c1c", "Once approved you cannot change marks!!");
    }
},
viewAnswer(answer){
    this.current_anwer = answer
this.answer = true
},
viewFile(file){
this.file = true
this.fileArr = file
for(let i=0;i<this.fileArr.length; i++){
if(this.fileArr[i].file_path.includes(".pdf")){
    this.fileArr[i].fileType = 'pdf'
}
if(this.fileArr[i].file_path.includes(".jpg") || this.fileArr[i].file_path.includes(".jpeg") ||this.fileArr[i].file_path.includes(".JPG") ||this.fileArr[i].file_path.includes(".JPEG")){
    this.fileArr[i].fileType = 'img'
}
if(this.fileArr[i].file_path.includes(".png") ||this.fileArr[i].file_path.includes(".PNG")){
    this.fileArr[i].fileType = 'img'
}

}
console.log('this.fileArr',this.fileArr);
},
            proceed() {
                // this.loading = true;
                const data = {
                    exam: this.exam,
                    course: this.course,
                };
                    if (this.exam && this.course) {
                            axios
                                .post("/PaperChecker/getLesData", data)
                                .then((res) => {
                                    if (res.data.flag == "YES") {
                                        this.stud_data = res.data.stud_data;
                                        if(this.stud_data.length == 0)
                                        this.showSnackbar("#b71c1c", "Data not found!!");
                                    } else {
                                    }
                                    this.unitBlock = false;
                                })
                                .catch((error) => {})
                                .finally(() => {
                                    this.loading = false;
                                });
                    } else {
                        this.loading = false;
                        this.showSnackbar("#b71c1c", "Please select required fields!!");
                    
                }
            },

            getunit() {
                this.unitBlock = true;
                const data = {
                    courseSrc: this.courseSrc,
                };
                axios
                    .post("/CopyQuestion/questioninfo", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.question_info = res.data.qinfo_list;
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },

            getunitDes() {
                this.unitBlock = true;
                const data = {
                    courseSrc: this.courseDes,
                };
                axios
                    .post("/CopyQuestion/questioninfo", data)
                    .then((res) => {
                        window.console.log(res);
                        if (res.data.msg == "200") {
                            this.question_info_des = res.data.qinfo_list;
                        } else {
                            this.message = res.data.msg;
                        }
                    })
                    .catch((error) => {
                        window.console.log("error:" + error);
                    })
                    .finally(() => (this.fetch_org_load = false));
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>

<style scoped>
    .mytable /deep/ thead th {
        /* background-color: hsla(190, 99%, 30%, 1) !important; */
        background-color: gray !important;
        color: white !important;
        white-space: nowrap !important;
    }
.answer{
    cursor: pointer  !important;
}
.answer >>> .v-input__slot::before {
  border-style: none !important;
}
.answer >>> input{
white-space: nowrap;
    text-overflow: ellipsis;}
.info1{
    font-weight: bold;
    padding-left: 5px;
}
    .unit {
        padding-left: 10rem;
    }
    .check {
        margin: 0px;
        padding: 0px 0px 0px 20px;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
    .select >>> .v-input__slot {
        background: white !important;
        border-color: hsla(190, 99%, 30%, 1) !important;
    }
    .downbtn {
        float: right;
    }
    .box {
        background-color: #add8e630;
        margin: 8px;
        padding: 8px;
    }
    .center {
        justify-content: center;
    }
    #inspire{
        border: 2px solid hsla(190, 99%, 30%, 1);
    }
embed{
    width: 1000px;
}
</style>
